/* Nova Publisher theme — lightweight, dependency-free */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';

  /* ---------- Tracking (only if tools already exist) ---------- */
  function track(name, params) {
    if (!w.NovaTheme || !w.NovaTheme.tracking) return;
    params = params || {};
    try {
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push(Object.assign({ event: name }, params));
      if (typeof w.gtag === 'function') w.gtag('event', name, params);
      if (typeof w.fbq === 'function') {
        if (name === 'nova_quote_submit') w.fbq('track', 'Lead', params);
        else if (name === 'nova_whatsapp_click') w.fbq('track', 'Contact', params);
        else w.fbq('trackCustom', name, params);
      }
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') {
        w.Shopify.analytics.publish(name, params);
      }
    } catch (e) {}
  }
  w.NovaTrack = track;
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-track]');
    if (t) track(t.getAttribute('data-track'), { location: (t.closest('[data-section-type]') || {}).getAttribute ? t.closest('[data-section-type]').getAttribute('data-section-type') : 'global' });
  });

  /* ---------- Sticky header ---------- */
  function initHeader() {
    var header = d.querySelector('[data-header]');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = '1';
    var onScroll = function () { header.classList.toggle('is-scrolled', w.scrollY > 8); };
    onScroll();
    w.addEventListener('scroll', onScroll, { passive: true });

    // Mega menu / dropdowns
    d.querySelectorAll('[data-dropdown]').forEach(function (item) {
      var btn = item.querySelector('[data-dropdown-toggle]');
      var timer;
      var open = function () { clearTimeout(timer); closeAll(item); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
      var close = function () { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); };
      btn.addEventListener('click', function (e) { e.preventDefault(); item.classList.contains('is-open') ? close() : open(); });
      item.addEventListener('mouseenter', function () { if (w.matchMedia('(hover:hover)').matches) open(); });
      item.addEventListener('mouseleave', function () { if (w.matchMedia('(hover:hover)').matches) timer = setTimeout(close, 160); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); btn.focus(); } });
    });
    function closeAll(except) {
      d.querySelectorAll('[data-dropdown].is-open').forEach(function (el) {
        if (el !== except) { el.classList.remove('is-open'); el.querySelector('[data-dropdown-toggle]').setAttribute('aria-expanded', 'false'); }
      });
    }
    d.addEventListener('click', function (e) { if (!e.target.closest('[data-dropdown]')) closeAll(); });

    // Mobile drawer
    var drawer = d.getElementById('NovaDrawer');
    if (!drawer) return;
    var toggle = d.querySelector('[data-drawer-open]');
    var lastFocus;
    function openDrawer() {
      lastFocus = d.activeElement;
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      toggle && toggle.setAttribute('aria-expanded', 'true');
      d.documentElement.classList.add('no-scroll');
      var f = drawer.querySelector(FOCUSABLE); f && setTimeout(function () { f.focus(); }, 60);
    }
    function closeDrawer() {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      toggle && toggle.setAttribute('aria-expanded', 'false');
      d.documentElement.classList.remove('no-scroll');
      lastFocus && lastFocus.focus();
    }
    toggle && toggle.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); trapTab(e, drawer); });
    drawer.querySelectorAll('a[href^="#"], [data-quote-open]').forEach(function (a) { a.addEventListener('click', function () { closeDrawer(); }); });
  }

  function trapTab(e, scope) {
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(scope.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Quote modal ---------- */
  function initQuote() {
    var modal = d.getElementById('NovaQuote');
    if (!modal) return;
    var dialog = modal.querySelector('.modal__dialog');
    var lastFocus;
    function open(src) {
      lastFocus = d.activeElement;
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false');
      d.documentElement.classList.add('no-scroll');
      setTimeout(function () { var f = modal.querySelector('input:not([type=hidden]):not([name=nova_hp]),select') || dialog; f.focus({ preventScroll: true }); }, 80);
      if (src !== 'auto') track('nova_quote_open', { location: src || 'unknown' });
    }
    function close() {
      modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true');
      d.documentElement.classList.remove('no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    w.NovaQuote = { open: open, close: close };
    d.addEventListener('click', function (e) {
      var t = e.target.closest('[data-quote-open], a[href="#quote"], a[href="/#quote"]');
      if (t) {
        e.preventDefault();
        var sec = t.closest('[data-section-type]');
        open(sec ? sec.getAttribute('data-section-type') : 'header');
      }
      if (e.target.closest('[data-quote-close]')) { e.preventDefault(); close(); }
    });
    modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); trapTab(e, modal); });
    if (location.hash === '#quote') open('url');

    initForms(open);
  }

  /* ---------- All lead forms (quote popup, contact page, newsletter) ---------- */
  var FORM_IDS = ['NovaQuoteForm', 'NovaContactForm', 'NovaNewsletter', 'NovaHeroForm'];
  function initForms(openModal) {
    var key = 'novaLastForm';
    var last = null;
    try { last = sessionStorage.getItem(key); } catch (e) {}
    var posted = d.querySelector('[data-form-success], [data-form-errors]');
    if (posted) {
      var id = last || 'NovaQuoteForm';
      var f = d.getElementById(id);
      if (f) {
        var ok = f.querySelector('[data-form-success]');
        var err = f.querySelector('[data-form-errors]');
        if (ok) {
          ok.hidden = false;
          var fields = f.querySelector('[data-form-fields]'); if (fields) fields.hidden = true;
          var title = f.querySelector('[data-form-title]'); if (title && title.dataset.successTitle) title.textContent = title.dataset.successTitle;
          var intro = f.querySelector('[data-form-intro]'); if (intro) intro.hidden = true;
          track(id === 'NovaNewsletter' ? 'nova_newsletter_submit' : 'nova_quote_submit', { form: id });
        } else if (err) { err.hidden = false; }
        if (id === 'NovaQuoteForm') openModal('auto');
        else setTimeout(function () { f.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); }, 300);
      }
      try { sessionStorage.removeItem(key); history.replaceState(null, '', location.pathname); } catch (e) {}
    }

    FORM_IDS.forEach(function (fid) {
      var form = d.getElementById(fid);
      if (!form || form.dataset.bound) return;
      form.dataset.bound = '1';
      var submitted = false;
      function validateField(field) {
        var input = field.querySelector('input,select,textarea');
        if (!input || !input.hasAttribute('required')) return true;
        var good = input.checkValidity() && String(input.value).trim() !== '';
        field.classList.toggle('has-error', !good);
        input.setAttribute('aria-invalid', good ? 'false' : 'true');
        var e2 = field.querySelector('.field__err');
        if (e2) { if (!e2.id) e2.id = input.id + '-err'; input.setAttribute('aria-describedby', e2.id); }
        return good;
      }
      form.querySelectorAll('.field').forEach(function (fl) {
        var input = fl.querySelector('input,select,textarea');
        if (!input) return;
        input.addEventListener('blur', function () { if (fl.classList.contains('has-error') || input.value) validateField(fl); });
        input.addEventListener('change', function () { if (fl.classList.contains('has-error')) validateField(fl); });
      });
      form.addEventListener('submit', function (e) {
        var hp = form.querySelector('[name="nova_hp"]');
        if (hp && hp.value) { e.preventDefault(); return; }
        if (submitted) { e.preventDefault(); return; }
        var firstBad = null;
        form.querySelectorAll('.field').forEach(function (fl) { if (!validateField(fl) && !firstBad) firstBad = fl; });
        var email = form.querySelector('input[type=email]');
        if (!firstBad && email && !email.checkValidity()) { e.preventDefault(); email.reportValidity(); return; }
        if (firstBad) { e.preventDefault(); var i = firstBad.querySelector('input,select,textarea'); i && i.focus(); return; }
        if (hp) hp.disabled = true;
        submitted = true;
        try { sessionStorage.setItem(key, fid); } catch (er) {}
        var btn = form.querySelector('[data-form-submit], button[type=submit]');
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      });
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initAccordion() {
    d.querySelectorAll('[data-accordion]').forEach(function (acc) {
      if (acc.dataset.bound) return; acc.dataset.bound = '1';
      var single = acc.hasAttribute('data-single');
      acc.querySelectorAll('.acc__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.acc__item');
          var willOpen = !item.classList.contains('is-open');
          if (single) acc.querySelectorAll('.acc__item.is-open').forEach(function (o) {
            if (o !== item) { o.classList.remove('is-open'); o.querySelector('.acc__q').setAttribute('aria-expanded', 'false'); }
          });
          item.classList.toggle('is-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Slider ---------- */
  function initSliders() {
    d.querySelectorAll('[data-slider]').forEach(function (s) {
      if (s.dataset.bound) return; s.dataset.bound = '1';
      var track = s.querySelector('.slider__track');
      var prev = s.querySelector('[data-prev]'), next = s.querySelector('[data-next]');
      if (!track) return;
      function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + 24 : track.clientWidth; }
      function update() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      w.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = d.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in w) || !d.documentElement.classList.contains('anim-on')) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { initHeader(); initQuote(); initAccordion(); initSliders(); initReveal(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor support
  d.addEventListener('shopify:section:load', function () { initAccordion(); initSliders(); initReveal(); initHeader(); });
  d.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('.acc__item');
    if (item && !item.classList.contains('is-open')) item.querySelector('.acc__q').click();
  });
})();
